import React from 'react';
import Navbar from '../components/Navbar';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <Navbar />
      <div className="privacy-policy-content">
        <div className="container">
          <h1>Privacy Policy</h1>
          <div className="privacy-policy-text">

            <h2>Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you create an account, submit forms, or contact us for inquiries about our educational services.</p>

            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to provide, maintain, and improve our educational services, process applications, communicate with you, and comply with legal obligations.</p>

            <h2>Information Sharing</h2>
            <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy.</p>

            <h2>Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>

            <h2>Your Rights</h2>
            <p>You have the right to access, update, or delete your personal information. Contact us if you wish to exercise these rights.</p>

            <h2>Contact Us</h2>
            <p>For questions about this Privacy Policy, please contact us at info@biyanis.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

